import Emitter from "tiny-emitter";

export const emitter = new Emitter();

export function showMessage(type, message) {
  emitter.emit(type, message);
}

export function show0RecordMessage(message) {
  let m = message ? message : 'No existen datos para la selección solicitada.';
  emitter.emit('none', m);
}

export function goTo(route) {
  emitter.emit("goto", route);
}

export function clearMessages() {
  emitter.emit("clear");
}
